import { useEffect, useMemo, useState } from 'react';
import type { LanguagePreference } from '../../shared/types';
import { createTranslator, detectLanguage } from '../lib/i18n';

const languageStorageKey = 'vault-kosmos:language';

export function usePreferences() {
  const [language, setLanguage] = useState<LanguagePreference>(() => loadLanguage());

  useEffect(() => {
    window.localStorage.setItem(languageStorageKey, language);
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    window.localStorage.removeItem('vault-kosmos:theme');
    document.documentElement.dataset.theme = 'dark';
    document.documentElement.dataset.themePreference = 'dark';
  }, []);

  return {
    language,
    setLanguage,
    toggleLanguage: () => setLanguage((current) => (current === 'de' ? 'en' : 'de')),
    t: useMemo(() => createTranslator(language), [language])
  };
}

function loadLanguage(): LanguagePreference {
  const stored = window.localStorage.getItem(languageStorageKey);
  return stored === 'de' || stored === 'en' ? stored : detectLanguage();
}
